import React from 'react';
import { Circle, CircleProps } from '@chakra-ui/react/box';
import { Stack } from '@chakra-ui/react/stack';
import { Skeleton as ChakraSkeleton } from '@chakra-ui/react/skeleton';
import { SkeletonProps } from '@chakra-ui/react/skeleton';

export interface SkeletonCircleProps extends SkeletonProps {
	size?: CircleProps['size'];
}

export const SkeletonCircle = React.forwardRef<HTMLDivElement, SkeletonCircleProps>(function SkeletonCircle(props, ref) {
	const { size, ...rest } = props;
	return (
		<Circle size={size} asChild ref={ref}>
			<ChakraSkeleton {...rest} />
		</Circle>
	);
});

export interface SkeletonTextProps extends SkeletonProps {
	noOfLines?: number;
}

export const SkeletonText = React.forwardRef<HTMLDivElement, SkeletonTextProps>(function SkeletonText(props, ref) {
	const { noOfLines = 3, gap, ...rest } = props;
	return (
		<Stack gap={gap} width="full" ref={ref}>
			{Array.from({ length: noOfLines }).map((_, index) => (
				<ChakraSkeleton height="4" key={index} {...props} _last={{ maxW: '80%' }} {...rest} />
			))}
		</Stack>
	);
});

export const Skeleton: unknown = ChakraSkeleton;
